import './ShellHeader.css';
import { useShellSidebar } from '../shell/ShellSidebarContext';

const SHELL_PAGES = {
  hub: {
    eyebrow: 'Mini-game hub',
    title: 'Stans-World',
    tagline: 'Play quick games, climb the boards, and cash out when luck lines up.',
  },
  profile: {
    eyebrow: 'Account',
    title: 'Profile',
    tagline: 'Your hub identity and progress—more profile tools soon.',
  },
  settings: {
    eyebrow: 'Preferences',
    title: 'Settings',
    tagline: 'Tune how the hub works for you—options arriving in a future update.',
  },
  notFound: {
    eyebrow: 'Lost in the clouds',
    title: 'Page not found',
    tagline: 'This path is not wired up yet. Use the links below or the menu to get back.',
  },
};

function ShellHeader({ tab }) {
  const page = SHELL_PAGES[tab] ?? SHELL_PAGES.hub;
  const { sidebarOpen, toggleSidebar } = useShellSidebar();

  return (
    <header className="shell-header" aria-live="polite">
      <button
        type="button"
        className="mobile-menu-btn shell-header-menu-btn"
        aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={sidebarOpen}
        aria-controls="app-sidebar"
        onClick={toggleSidebar}
      >
        <span className="mobile-menu-btn__icon" aria-hidden="true" />
      </button>
      <span className="shell-header-accent" aria-hidden />
      <div className="shell-header-copy">
        <p className="shell-header-eyebrow">{page.eyebrow}</p>
        <h1 className="shell-header-title">{page.title}</h1>
        <p className="shell-header-tagline">{page.tagline}</p>
      </div>
    </header>
  );
}

export default ShellHeader;
